import { apiClient } from "../../apiClient";
import { ForexResponse } from "./type";

export const forexService = {
  getAllRates: async (): Promise<ForexResponse> => {
    const response = await apiClient.get("/forex/rates");
    return response.data;
  },

  getRateByCurrency: async (currency: string): Promise<ForexResponse> => {
    const response = await apiClient.get(`/forex/rates/${currency}`);
    return response.data;
  },
};
